import React, { useState } from 'react';
import { View, Text, TextInput } from 'react-native';

import { setSingleOptionSelection } from '../services/CommonUtils';

import { PrimaryCTA } from '../widgets/CommonCTA';
import { CloseIcon, HorizontalDivider } from '../widgets/Common-Widget';

import Modal from 'react-native-modal';
import AppStyles from '../../AppStyles';
import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';
import RadioButton from '../widgets/RadioButton';

const SingleOptionSelectionBottomSheet = (props) => {
    const showModal = props.showModal
    const modalTitle = props.modalTitle
    const optionsList = props.optionsList
    const closeModal = props.closeModal
    const primaryAction = props.primaryAction
    const ctaTitle = props?.ctaTitle ?? 'Submit'

    const [selectedOption, setSelectedOption] = useState({
        index: -1,
        option: {},
        toggleView: false
    })
    const [description, setDescription] = useState('')

    function checkCTADisable() {
        if (selectedOption?.index >= 0) {
            if (selectedOption.toggleView && !description)
                return true
            else return false
        } else return true
    }

    return <Modal backdropOpacity={0.70}
        deviceWidth={window.innerWidth}
        deviceHeight={window.innerHeight}
        animationOutTiming={1000}
        animationOut={'slideOutDown'}
        isVisible={showModal}
        style={[{ justifyContent: 'flex-end', margin: 'auto', width: AppTheme.appWidth }]}
        onBackdropPress={() => { props.setBottomSheet({ active: false }) }}>
        <View style={{
            backgroundColor: 'white', padding: 16,
            borderTopRightRadius: 12, borderTopLeftRadius: 12
        }}>

            <View style={[AppStyles.flexRowSpaceBetween]}>
                <Text style={[TextStyle.text20b]}>{modalTitle}</Text>
                <CloseIcon onPress={() => closeModal()} />
            </View>

            <View style={{ marginTop: 12, marginBottom: 20 }}>
                {optionsList.map((option, index) =>
                    <View key={index}>
                        <View style={[AppStyles.flexRowStart, { marginVertical: 16 }]}>
                            <RadioButton onPress={() => {
                                setSingleOptionSelection(option, index, {
                                    setSelectedOption: setSelectedOption,
                                    setDescription: setDescription
                                })
                            }} checked={selectedOption.index == index} />
                            <Text style={[TextStyle.text14b]}>
                                {option['dispStr']}</Text>
                        </View>

                        {index == optionsList.length - 1 ?
                            null : <HorizontalDivider width={AppTheme.appWidth - 32} />}

                    </View>)
                }
            </View>

            {selectedOption.toggleView ? <TextInput numberOfLines={1}
                multiline={true} style={[TextStyle.text14b, {
                    borderWidth: 1, borderColor: AppTheme.color.primary,
                    color: AppTheme.color.grey.text, borderRadius: 8,
                    paddingHorizontal: 16, paddingVertical: 10
                }]} onChangeText={(text) => { setDescription(text) }}
                placeholder="If you have any other reason, write here..."
                value={description} /> : null}

            <PrimaryCTA text={ctaTitle} disabled={checkCTADisable()}
                action={() => { primaryAction(selectedOption.option['value'], description) }} />

        </View>
    </Modal>
}

export default SingleOptionSelectionBottomSheet